<template>
  <div class="content">
    <h1>Payment</h1>
    <div class="row name-input-group">
      <div class="col-md-6">
        <label class="pure-material-textfield-outlined">
          <input
            class="form-control"
            type="text"
            v-model="firstName"
            @blur="checkFirstName"
            placeholder=" "
          />
          <span>Card First Name</span>
          <p class="error-message">{{firstname_message || "&nbsp;"}}</p>
        </label>
      </div>
      <div class="col-md-6">
        <label class="pure-material-textfield-outlined">
          <input
            type="text"
            class="form-control"
            v-model="lastName"
            @blur="checkLastName"
            placeholder=" "
          />
          <span>Card Last Name</span>
          <p class="error-message">{{lastname_message || "&nbsp;"}}</p>
        </label>
      </div>
    </div>

    <div>
      <label class="md-form mb-0 pure-material-textfield-outlined">
        <!-- <label data-error="wrong" data-success="right" for="paid-stripe-card">Credit or debit card</label> -->
        <div
          @blur="checkUserNameInput"
          class="form-control"
          style="border: solid 1px; background:transparent"
          ref="card"
        ></div>
        <div id="card-errors" role="alert"></div>
        <p class="error-message" id="card-errors" role="alert">{{card_error || "&nbsp;"}}</p>
      </label>
    </div>
    <div style="text-align:center; font-weight: bold; color: #4a4a4a;">
      <p>You will be charged {{plan}} / mo + tax</p>
      <div style="margin-top:1rem">
        <v-icon name="lock" style="display: inline-block; height: 1.5rem; color: #259B24;"></v-icon>
        <p style="display: inline-block">Your credit card is safe with us</p>
      </div>
    </div>
  </div>
</template>


<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { mapState, mapActions } from "vuex";
import globalConstants from "@/utils/global-constants.js";
// Step 1: import stripe
let stripe = Stripe(globalConstants.STRIPE_KEY);
let paymentRequest = null;

// Step 2: Create an instance of Elements.
let elements = stripe.elements();
// Step 3: Create paymentRequestButton Element
// console.log("paymentRequest is: ", paymentRequest);
let prButton = null;
// console.log("prButton is: ", prButton);
// Step 4: Create input field for card
let card = null;

export default {
  props: {
    plan: {
      type: String,
      default: "Starter"
    }
  },

  computed: {
    firstName: {
      get() {
        return this.$store.getters.cardFirstName;
      },
      set(val) {
        this.$store.commit("setCardFirstName", val.toUpperCase());
      }
    },

    lastName: {
      get() {
        return this.$store.getters.cardLastName;
      },
      set(val) {
        this.$store.commit("setCardLastName", val.toUpperCase());
      }
    },

    ...mapState({
      loggedIn: state => state.UserService.idToken !== null,
      formError: state => state.UserService.formError,
      email: state => state.UserService.userEmail,
      password: state => state.UserService.userPassword,
      userFirstName: state => state.UserService.userFirstName,
      userLastName: state => state.UserService.userLastName,
      company: state => state.UserService.companyName,
      title: state => state.UserService.positionTitle,
      telephone: state => state.UserService.telephoneNumber,
      loading: state => state.UserService.loading
    })
  },

  data() {
    return {
      firstname_message: "",
      lastname_message: "",
      error_message: "",
      card_error: ""
    };
  },

  components: {
    PulseLoader
  },

  mounted() {
    if (this.loggedIn) {
      this.$store.commit("setUserEmail", this.getWindowLocalStorage("email"));
    }
    this.initStripeCard(1);
  },
  methods: {
    checkFirstName() {
      if (this.firstName.length < 1) {
        this.firstname_message = "*Please provide your first name";
        // check if name only contains letters
      } else if (/[^a-zA-Z]/.test(this.firstName)) {
        // if contains charactar other than numbers
        this.firstname_message = "*Please provide valid name";
      } else this.firstname_message = "";
    },

    checkLastName() {
      if (this.lastName.length < 1) {
        this.lastname_message = "*Please provide your last name";
        // check if name only contains letters
      } else if (/[^a-zA-Z]/.test(this.lastName)) {
        // if contains charactar other than numbers
        this.lastname_message = "*Please provide valid name";
      } else this.lastname_message = "";
    },

    checkUserNameInput() {
      this.checkFirstName();
      this.checkLastName();
    },

    createPremiumAccount() {
      this.validatePayForm();
      if (!this.formError) {
        this.createSubscription();
      }
    },

    updatePremiumPlan() {
      this.validatePayForm();
      if (!this.formError) {
        this.createSubscription();
      }
    },

    /**
     * Step1 : Valid form input
     */
    validatePayForm() {
      this.checkUserNameInput();
      const { firstname_message, lastname_message } = this;
      const payload = { firstname_message, lastname_message };
      this.$store.dispatch("validateForm", payload);
    },

    /**
     * Step 2 : Request Stripe for a token
     */
    createSubscription() {
      const {
        email,
        plan,
        userFirstName,
        userLastName,
        password,
        firstName,
        lastName,
        company,
        title,
        telephone
      } = this;
      // console.log("checkSignupForm() card is: ", card);
      this.$store.commit("setLoadingStatus", true);
      // this.loading_2 = true;
      stripe.createToken(card).then(result => {
        // Inform the user if there was an error.
        // Otherwise, Send the token to our backend server.
        if (result.error) {
          this.card_error = result.error.message;
          this.$store.commit("setLoadingStatus", false);
        } else {
          const stripeToken = result.token.id;
          const formData = {
            email,
            plan,
            stripeToken,
            userFirstName,
            userLastName,
            password,
            firstName,
            lastName,
            company,
            title,
            telephone
          };
          this.submitForm(formData);
        }
      });
    },

    /**
     *  Step 3: submit form to complete transaction
     */
    submitForm(formData) {
      console.log(formData);
      // Step 1: obtain form data
      this.$store.commit("setLoadingStatus", true);
      // this.loading_2 = true;
      const formAction = this.loggedIn ? "subscripe" : "paidSignup";
      this.$store
        .dispatch(formAction, formData)
        .then(message => {
          console.log("message is: ", message);
          this.$store.commit("setLoadingStatus", false);
          this.$store.commit("goToNextStep");
          this.updateUserData();
        })
        .catch(err => {
          if (err.response && err.response.data && err.response.data.message) {
            let message = err.response.data.message;
            if (message.startsWith("Your card"))
              message = "Your card information is incorrect !";
            this.card_error = message;
          } else if (err.message) {
            this.card_error = err.message;
          } else {
            this.card_error = err;
          }

          // console.log("error is: ", err)
          this.$store.commit("setLoadingStatus", false);
          this.$store.commit("setFormError", true);
        });
    },

    updateUserData() {
      // const vm = this;
      const token = this.getWindowLocalStorage("token");
      this.$store
        .dispatch("getProfile", { token })
        .then(response => response.json())
        .then(res => {
          // console.log(res);
          this.$store.commit("saveUserInfoInState", res);
          let plan = res.plan ? res.plan : "free";
          this.setWindowLocalStorage("userPlan", plan);
          this.setWindowLocalStorage("apikey", res.accessKey);
        })
        .catch(err => {
          console.log(err.response);
          vm.loading = 0;
        });
    },

    initStripeCard(price) {
      // Step 1: Check the availability of the Payment Request API first.
      if (paymentRequest == null) {
        paymentRequest = stripe.paymentRequest({
          country: "US",
          currency: "usd",
          total: {
            label: "Institutional",
            amount: price * 100 // cents
          },
          requestPayerName: true,
          requestPayerEmail: true
        });
      }

      // ***always show prButton for sign up***
      let that = this;
      if (prButton == null) {
        prButton = elements.create("paymentRequestButton", {
          paymentRequest: paymentRequest
        });
      }

      paymentRequest
        .canMakePayment()
        .then(function(result) {
          // console.log("canMakePayment() result is: ", result);
          // if (result) {
          that.prButton.mount(that.$refs.paymentRequestButton);
          // } else {
          //   document.getElementById("paymentRequestButton").style.display = "none";
          // }
        })
        .catch(function(error) {
          console.log("can make payment, error is: ", error);
        });

      // Step 2: set card style
      let style = {
        base: {
          color: "#32325d",
          fontFamily: "sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#aab7c4"
          }
        },
        invalid: {
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };

      // Create an instance of the card Element.
      if (card == null) {
        card = elements.create("card", { style: style });
      }
      // Add an instance of the card Element into the `card-element` <div>.
      console.log("mount card!!!");
      card.mount(this.$refs.card);
      // Handle real-time validation errors from the card Element.
      card.addEventListener("change", event => {
        event.error
          ? (this.card_error = event.error.message)
          : (this.card_error = "");
      });
    }
  }
};
</script>


<style scoped>
* {
  font-family: Jura;
  font-weight: bold !important;
}

.content {
  height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
h1 {
  height: 63px;
  font-family: Jura;
  font-size: 48px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 1.41px;
  /* margin-top: 5rem; */
  color: #4a4a4a;
}

.icon:hover {
  cursor: pointer;
}

.name-input-group {
  justify-content: space-between;
}

.error-message {
  font-size: 16px;
  color: red;
  /* margin-top: -10px;
  margin-bottom: 10px; */
  margin-left: 2px;
  text-align: left;
}

/* css effects for input */

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  /* margin: 10px auto; */
  display: block;
  padding-top: 6px;

  font-family: var(
    --pure-material-font,
    "Arial, Helvetica, sans-serif",
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  /* border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  /* color: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined
      > input
      + span
      .pure-material-textfield-outlined
      > input
      + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.1s;
    }
  }
}

@media screen and (max-width: 1400px) {
  .card {
    width: 50%;
  }
}

@media screen and (max-width: 1100px) {
  .card {
    width: 60%;
  }
}
@media screen and (max-width: 800px) {
  .tab_change {
    /* float: none;
			margin:0; */
    width: 100%;
    font-size: 0.5rem;
    flex-direction: column;
  }
  .card {
    width: 80%;
  }
}

@media screen and (max-width: 600px) {
  .card {
    width: 100%;
  }

  #terms {
    width: 15rem !important;
  }
}

@media screen and (max-width: 450px) {
  .btn-info {
    width: 80%;
  }

  .pure-material-textfield-outlined {
    /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
    width: 80%;
  }
  h2 {
    font-size: 1rem;
    font-weight: bold;
    margin-top: 8%;
  }
  .selector > div {
    padding: 8px 40px;
  }
}

/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>






// WEBPACK FOOTER //
// src/components/form/payment-form.vue